kv.controller('costCenterEditCtrl', function ($uibModalInstance, data, $injector, $scope) {
	return new dictionaryEditCtrl($uibModalInstance, data, $injector, $scope, {
		entity: "cost_center",
		primaryKey: "cost_center_id",
		newEntity:{
		},
		prepareDataToSave: function () {
			let cmdate = this.getInjection('cmdate');
			let dataToSend = angular.copy(this.data);
			dataToSend.date = cmdate.toServer(this.data.date);
			return dataToSend;
		}
	});
});